module.exports = __webpack_public_path__ + "img/galeria-pacs-clinicas-1.a94dd1f8.png";